var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"read-more"},[_c('span',{staticClass:"read-more__content"},[_vm._v("Les Mer")]),_c('FontAwesomeIcon',{staticClass:"read-more__icon",attrs:{"icon":['fas', 'chevron-down'],"size":"1x"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }